export class LanguageSwitcherModule {

	constructor() {
		this.langComponent = document.querySelector("[data-language-commponent]");
		this.langButton = document.querySelector("[data-language-button]");
		this.init();
	}

	init() {
		this.langButton.addEventListener('click', (e) => this.toggleLanguageSwitcher(e));
	}

	toggleLanguageSwitcher() {
		const isOpen = this.langComponent.classList.contains('active');

		if (!isOpen) {
			this.openLanguageSwitcher();
		} else {
			this.closeLanguageSwitcher();
		}
	}

	openLanguageSwitcher() {
		this.langComponent.classList.add('active');
		this.langButton.setAttribute('aria-expanded', true);
		$('body').on('click.ipcolangswitch', (e) => { this.closeSwitcherIfOutsideAction(e) });
	}

	closeLanguageSwitcher() {
		this.langComponent.classList.remove('active');
		this.langButton.setAttribute('aria-expanded', false);
		$('body').off('.ipcolangswitch');
	}

	/**
	 * close languageswitcher if click outside of element
	 */
	closeSwitcherIfOutsideAction(e) {
		if (!$(e.target).closest('.language-switcher').length) {
			this.closeLanguageSwitcher();
		}
	}
}
